// extracted by mini-css-extract-plugin
export default {"iconAndTitleContainer":"webpack-concepts-Extraction-Blocks-shared-IconAndTitle-module__iconAndTitleContainer"};